import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useRef, useEffect } from 'react';
import LTTooltip from '../LTTooltip/index.js';
import { VisuallyHiddenContainer, StyledNavListItem, NavListContentWrapper } from './styles.js';
import { createUniqueID, isEnterOrSpacePressed, focusTabOnArrow } from '../../utils/functions.js';
import { NavList } from '@primer/react';

var LTNavList = function LTNavList(_a) {
  var _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? "" : _b,
    _c = _a.forwardRef,
    forwardRef = _c === void 0 ? null : _c,
    _d = _a.extraItemStyles,
    extraItemStyles = _d === void 0 ? {} : _d,
    _e = _a.extraStyles,
    extraStyles = _e === void 0 ? {} : _e,
    _f = _a.handleSelectedTab,
    handleSelectedTab = _f === void 0 ? function () {} : _f,
    _g = _a.listItems,
    listItems = _g === void 0 ? [] : _g,
    _h = _a.selectedTab,
    selectedTab = _h === void 0 ? "" : _h,
    _j = _a.showTruncatedName,
    showTruncatedName = _j === void 0 ? false : _j,
    _k = _a.tabIdPrefix,
    tabIdPrefix = _k === void 0 ? "" : _k;
  var navListsRef = useRef([]);
  useEffect(function () {
    var navElement = document.getElementById("navlist_item");
    // Check if the nav element exists
    if (navElement) {
      var ulElement = navElement.querySelector("ul");
      // Check if the <ul> element exists within the <nav>
      if (ulElement) {
        // Add role="tablist" attribute to the <ul> element
        ulElement.setAttribute("role", "tablist");
        // Add aria-orientation="vertical" attribute to the <ul> element
        ulElement.setAttribute("aria-orientation", "vertical");
      }
    }
  }, []);
  var navId = createUniqueID("navList");
  var listItemsToDisplay = listItems.filter(function (item) {
    return item.showItem !== false;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VisuallyHiddenContainer, {
    id: navId
  }, ariaLabel), /*#__PURE__*/React.createElement(NavList, {
    "aria-labelledby": navId,
    ref: forwardRef,
    id: "navlist_item",
    sx: __assign({}, extraStyles)
  }, listItemsToDisplay === null || listItemsToDisplay === void 0 ? void 0 : listItemsToDisplay.map(function (listItem, index) {
    var _a = listItem || {},
      _b = _a.contentId,
      contentId = _b === void 0 ? "" : _b,
      _c = _a.displayName,
      displayName = _c === void 0 ? "" : _c,
      _d = _a.leadingIcon,
      leadingIcon = _d === void 0 ? "" : _d,
      _e = _a.name,
      name = _e === void 0 ? "" : _e,
      _f = _a.truncatedDisplayName,
      truncatedDisplayName = _f === void 0 ? "" : _f,
      _g = _a.value,
      value = _g === void 0 ? "" : _g;
    return /*#__PURE__*/React.createElement(StyledNavListItem, {
      "aria-controls": selectedTab === value ? contentId : undefined,
      "aria-current": selectedTab === value && "page",
      "aria-label": "".concat(displayName),
      "aria-selected": selectedTab === value,
      className: selectedTab === value ? "activeItem" : "",
      key: "".concat(name, "-").concat(index),
      onClick: function onClick(e) {
        if (value !== selectedTab) {
          handleSelectedTab(listItem, e);
        }
      },
      onKeyDown: function onKeyDown(e) {
        if (isEnterOrSpacePressed(e)) {
          if (value !== selectedTab) {
            handleSelectedTab(listItem, e);
          }
        } else {
          var lastIndex = listItemsToDisplay.length - 1;
          focusTabOnArrow(e, "vertical", navListsRef, index, lastIndex);
        }
      },
      id: "".concat(tabIdPrefix, "-").concat(name.replace(/\s+/g, "-")),
      role: "tab",
      ref: function ref(el) {
        return navListsRef.current[index] = el;
      },
      tabIndex: selectedTab === value ? 0 : -1,
      style: __assign({}, extraItemStyles)
    }, /*#__PURE__*/React.createElement(NavListContentWrapper, null, leadingIcon && /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "2px"
      }
    }, leadingIcon), showTruncatedName ? /*#__PURE__*/React.createElement(LTTooltip, {
      text: displayName,
      direction: LTTooltip.Direction.BOTTOM
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "8px"
      }
    }, truncatedDisplayName)) : /*#__PURE__*/React.createElement("span", {
      style: {
        display: "inline-block",
        marginLeft: "8px"
      }
    }, displayName)));
  })));
};

export { LTNavList as default };
